import React, { useEffect, useState } from 'react';

const Hero = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative h-screen max-h-[90vh] overflow-hidden">
      {/* Immagine di sfondo con parallax */}
      <div 
        className="absolute inset-0 z-0"
        style={{ 
          backgroundImage: 'url("/images/hero.webp")',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          filter: 'blur(2px) brightness(0.5) saturate(1.2) contrast(1.2)',
          transform: `scale(1.1) translateY(${scrollPosition * 0.15}px)`,
          transition: 'transform 0.1s ease-out'
        }}
      ></div>
      
      {/* Overlay con texture metallica */}
      <div 
        className="absolute inset-0 bg-gradient-to-br from-black/80 via-gray-900/60 to-black/90 z-1"
        style={{
          backgroundImage: 'radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.04) 1%, transparent 1%), radial-gradient(circle at 75% 75%, rgba(255, 255, 255, 0.04) 1%, transparent 1%)',
          backgroundSize: '60px 60px'
        }}
      ></div>
      
      {/* Contenuto principale */}
      <div className="relative h-full z-10 flex items-center">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl">
            {/* Testo principale */}
            <div 
              className="inline-flex items-center space-x-2 mb-1"
              style={{ transform: `translateY(${-scrollPosition * 0.08}px)` }}
            >
              <span className="w-12 h-[1px] bg-gray-400"></span>
              <span className="text-gray-300 uppercase text-xs tracking-widest font-light">Eccellenza nel settore dal 2000</span>
            </div>
            
            <h1 
              className="text-6xl lg:text-8xl font-bold text-white leading-none"
              style={{ transform: `translateY(${-scrollPosition * 0.05}px)` }}
            >
              <span className="block tracking-tight">MAS METAL</span>
              <span className="text-3xl lg:text-4xl text-gray-300 font-light mt-3 block tracking-wide">
                Commercio all'ingrosso metalli
              </span>
            </h1>
            
            <p 
              className="text-lg text-gray-300 max-w-2xl leading-relaxed mt-6"
              style={{ transform: `translateY(${-scrollPosition * 0.03}px)` }}
            >
              Leader nella distribuzione di sottoprodotti derivanti dalla lavorazione industriale, 
              con soluzioni personalizzate per ogni esigenza aziendale.
            </p>
            
            <ul 
              className="flex flex-col space-y-2 mt-6 text-gray-300 max-w-xl"
              style={{ transform: `translateY(${-scrollPosition * 0.02}px)` }}
            >
              <li className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-400 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4" />
                </svg>
                Commercio di sottoprodotti metallici di alta qualità
              </li>
              <li className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-400 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4" />
                </svg>
                Logistica integrata e servizi personalizzati
              </li>
              <li className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-400 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4" />
                </svg>
                Soluzioni efficienti per diversi settori industriali
              </li>
            </ul>
            
            <div 
              className="flex flex-wrap gap-5 pt-8"
              style={{ transform: `translateY(${-scrollPosition * 0.01}px)` }}
            >
              <a 
                href="#contatti" 
                className="group relative px-8 py-4 bg-white overflow-hidden rounded font-medium text-gray-900 inline-block shadow-lg"
              >
                <span className="relative z-10">Richiedi Preventivo</span>
                <div className="absolute inset-0 bg-gradient-to-r from-gray-100 to-gray-300 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
              </a>
              <a 
                href="#servizi" 
                className="group relative px-8 py-4 bg-transparent overflow-hidden border border-gray-400 rounded font-medium text-white inline-block"
              >
                <span className="relative z-10 group-hover:text-gray-900 transition-colors duration-300">I Nostri Servizi</span>
                <div className="absolute inset-0 bg-white transform -translate-y-full group-hover:translate-y-0 transition-transform duration-500"></div>
              </a>
            </div>
          </div>
        </div>
      </div>
      
      {/* Decorazioni angolari */}
      <div className="absolute top-8 right-8 w-32 h-32 border-t-2 border-r-2 border-white/20 z-10"></div>
      <div className="absolute bottom-8 left-8 w-32 h-32 border-b-2 border-l-2 border-white/20 z-10"></div>
      
      {/* Freccia verso il basso per indicare lo scroll */}
      <div className="absolute left-1/2 bottom-10 transform -translate-x-1/2 z-20 animate-bounce">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white opacity-70" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>
  );
};

export default Hero;